import React from "react";
import { string, number, object, func, oneOfType, bool } from "prop-types";
import { Row, Col } from "react-bootstrap";
import Select from "react-select-plus"; // TODO: migrate to react-select
import "react-select-plus/dist/react-select-plus.css";
import cautionIcon from "resources/images/caution-icon.png";
import TestBatteryInfoCards from "./TestBatteryInfoCards";
import { getAdjustedTimeMultiplierOptions } from "./helpers";

const AdjustedTime = ({
  testBatterySubTests,
  timeFactor,
  handleAdjustedTimeMultiplier,
  isAdjustedTimeMultiplierEnabled,
  job,
  testBatteryId,
  jobDetailId,
  testMakerTests,
  fromScheduleExistingCandidates,
  // eslint-disable-next-line no-unused-vars
  locale,
}) => (
  <Row className="mt-3">
    <Col>
      <h4 className="mb-3">Adjusted Time</h4>
      <p>
        You can choose to offer extended time to candidates for all timed
        test(s) associated with this job.
      </p>
      <Row
        className="mt-3 mb-3 mx-0 p-3"
        style={{ backgroundColor: "#fff5e5", borderRadius: "2px" }}
      >
        <Col
          lg={1}
          md={1}
          sm={1}
          xs={1}
          className="px-0 text-right"
          style={{ maxWidth: "40px" }}
        >
          <img
            src={cautionIcon}
            alt="caution"
            width="16"
            height="16"
            className="mr-2"
          />
        </Col>
        <Col lg={11} md={11} sm={11} xs={11} className="pl-0">
          <p className="mb-0" style={{ color: "#b27100" }}>
            A time adjustment will affect candidate results. Please contact your
            Customer Success Manager before making adjustments.
          </p>
        </Col>
      </Row>
      <TestBatteryInfoCards
        testBatterySubTests={testBatterySubTests}
        job={job}
        testBatteryId={testBatteryId}
        jobDetailId={jobDetailId}
        timeFactor={Number(timeFactor)}
        testMakerTests={testMakerTests}
        fromScheduleExistingCandidates={fromScheduleExistingCandidates}
        filterBy="adjustedTime"
        assessmentSettings={
          fromScheduleExistingCandidates
            ? job && job.get("assessmentSettings")
            : job && job.getIn([jobDetailId, "assessmentSettings"])
        }
      />
      <div className="advancedSettingsGrayInputRow">
        {/* lineHeight is used to vertically align the text with the select component */}
        <div className="font-weight-bold" style={{ lineHeight: "36px" }}>
          Adjusted Time Multiplier
        </div>
        <Select
          name="adjustedTimeMultiplier"
          className="adjustedTimeMultiplierSelect"
          id="adjustedTimeMultiplier"
          value={Number(timeFactor)}
          options={getAdjustedTimeMultiplierOptions(
            isAdjustedTimeMultiplierEnabled
          )}
          onChange={handleAdjustedTimeMultiplier}
          clearable={false}
          style={{ width: "150px" }}
        />
      </div>
    </Col>
  </Row>
);

AdjustedTime.propTypes = {
  testBatterySubTests: object,
  timeFactor: oneOfType([number, string]),
  handleAdjustedTimeMultiplier: func,
  job: object,
  isAdjustedTimeMultiplierEnabled: bool,
  testBatteryId: number,
  jobDetailId: string,
  testMakerTests: object,
  fromScheduleExistingCandidates: bool,
  locale: string,
};

export default AdjustedTime;
